import { Suspense } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import ChatAssistant, { openHankChat } from './components/feature/ChatAssistant';
import { ChatFAB } from './components/ui/v2/ChatFAB';
import type { Lang } from './lib/lang';

// [T223 hub 收口] FAB 的可及名。与 Header.tsx 的 ASSESSMENT_CTA 同一形制(i18n 审计认可的
// 组件内双语对):文案键属措辞另案,src/i18n/** 不在本卡写面。
const FAB_LABEL: Record<Lang, string> = {
  en: 'Chat with us',
  zh: '在线咨询',
};
import ErrorBoundary from './components/feature/ErrorBoundary';
import ScrollToTop from './components/feature/ScrollToTop';

function PageFallback() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center" aria-busy="true">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-200 border-t-teal-600"></div>
    </div>
  );
}

// Authenticated portals (/intake*, /admin*) carry their own single-purpose
// header, so the marketing chrome is suppressed there — stacking both gave two
// headers + two footers on every portal page (owner visual-gate feedback,
// 2026-07-11). /triage keeps the chrome: it is part of the public funnel.
// [T168] /consult-prep is portal-class too (I5 exception declared on the card):
// a POST-payment focus surface with its own header/licence footer — the
// marketing nav (with its "Book Consultation" CTA) is wrong chrome for someone
// who has already booked.
// Hank (ChatAssistant) stays on every surface — clients use it mid-intake (T76),
// staff use 顾问模式 in admin (T81).
function AppShell() {
  const { pathname } = useLocation();
  const zh = pathname === '/zh' || pathname.startsWith('/zh/');
  const portal = pathname.startsWith('/intake') || pathname.startsWith('/admin')
    || pathname.startsWith('/consult-prep') || pathname.startsWith('/reschedule');
  return (
    <div className="flex flex-col min-h-screen">
      {!portal && <Header />}
      <main id="main-content" tabIndex={-1} className="flex-grow focus:outline-none">
        <ErrorBoundary>
          <Suspense fallback={<PageFallback />}>
            <AppRoutes />
          </Suspense>
        </ErrorBoundary>
      </main>
      {!portal && <Footer />}
      <ChatAssistant launcher="external" />
      <ChatFAB
        onOpen={() => openHankChat('')}
        label={FAB_LABEL[zh ? 'zh' : 'en']}
        icon={<i className="ri-message-3-line text-xl" aria-hidden="true"></i>}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppShell />
    </BrowserRouter>
  );
}

export default App;
